export default "<bar-rating [readOnly]=\"'true'\" theme=\"fontawesome-o\" [class]=\"className\" [rate]=\"rate\" [max]=\"5\"></bar-rating>";